<script lang="ts" setup>
defineProps<{
  pages: any
}>()

const localeRoute = useLocaleRoute()
const { t } = useI18n()
const { width } = useWindowSize()

const slidesOffsetBefore = computed(() => (width.value < 1280 ? 20 : 0))
const slidesOffsetAfter = computed(() => (width.value < 1280 ? 20 : 0))

const swiperBreakpoints = computed(() => ({
  320: { slidesPerView: 1.1 },
  375: { slidesPerView: 1.2 },
  480: { slidesPerView: 1.5 },
  640: { slidesPerView: 1.8 },
  800: { slidesPerView: 2.2 },
  1000: { slidesPerView: 2.5 },
  1100: { slidesPerView: 2.8 },
  1280: { slidesPerView: 3 },
}))
</script>

<template>
  <ClientOnly>
    <swiper-container
      :space-between="20"
      :slidesOffsetBefore="slidesOffsetBefore"
      :slidesOffsetAfter="slidesOffsetAfter"
      :breakpoints="swiperBreakpoints"
    >
      <swiper-slide v-for="item in pages">
        <NuxtLink
          :to="localeRoute('/blog/' + item.slug)"
          class="bg-[#272727] rounded-lg flex"
        >
          <div class="flex flex-col">
            <NuxtImg
              loading="lazy"
              :alt="item.title"
              class="rounded-t-lg h-49.75 w-full object-cover"
              :src="item.image.url || ''"
            />
            <div
              class="rounded-b-lg px-4.5 pt-7 pb-3.5 h-64 flex flex-col justify-between items-start"
            >
              <div>
                <div class="flex flex-row items-center">
                  <img
                    :alt="item.updatedAt"
                    src="~/assets/images/nft-tickets/event-date.svg"
                    class="w-4 h-4"
                  />
                  <span
                    class="ml-1 text-xs font-500 tracking-wide text-[#A3A3A3]"
                  >
                    {{ $dayjs(item.updatedAt).format('LL') }}
                  </span>
                </div>
                <div
                  class="mt-1.5 text-lg tracking-wide leading-snug line-clamp-3"
                >
                  {{ item.title }}
                </div>
                <div
                  class="font-300 text-base tracking-wide leading-tight mt-1.5 text-[#D3D3D3] line-clamp-4"
                >
                  {{ item.description }}
                </div>
              </div>
              <button class="text-base tracking-wide text-[#286EFF]">
                {{ t('read-more') }}
              </button>
            </div>
          </div>
        </NuxtLink>
      </swiper-slide>
    </swiper-container>
  </ClientOnly>
</template>
